@if (title()) {
<h2 class="mb-1" [attr.data-e2e]="e2e() + '-title'">{{ title() }}</h2>
}

<div [attr.data-e2e]="e2e() + '-items'">
  <div ngbAccordion class="accordion {{ customStyle() }}">
    @for (item of normalizedItems(); track item; let index = $index) {
    <div ngbAccordionItem class="card">
      <h2 ngbAccordionHeader class="card-header no-signature">
        <button ngbAccordionButton [attr.data-e2e]="e2e() + '-items-' + index">
          <div class="accordion-card-title">
            <span class="accordion-title">{{ item.title }}</span>
            <span class="accordion-icon"></span>
          </div>
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody class="card-body">
          <ng-template>
            @for (text of item.description; track text; let index = $index) {
            <p class="standard text-mw" [attr.data-e2e]="e2e() + '-items-' + index" [innerHTML]="text"></p>
            } @if (item.link; as link) {
            <a
              class="o-link-arrow text-mw"
              [href]="link.url"
              [attr.data-e2e]="e2e() + '-items-link'"
              [attr.aria-label]="ariaLabel()"
              (click)="clickAccordionLink.emit()"
            >
              {{ link.label }}
            </a>
            }
          </ng-template>
        </div>
      </div>
    </div>
    }
  </div>
</div>
